/**
 * @typedef {Object} FeatureFlags
 * @property {boolean} FEATURE_VIDEO
 * @property {boolean} FEATURE_NOTIFICATIONS
 * @property {boolean} FEATURE_FILES
 * @property {boolean} FEATURE_ANALYTICS
 * @property {boolean} FEATURE_MESSAGING
 * @property {boolean} FEATURE_FEEDBACK
 * @property {boolean} FEATURE_PATIENT_DASHBOARD
 * @property {boolean} FEATURE_PATIENT_MESSAGING
 * @property {boolean} FEATURE_PATIENT_BILLING
 * @property {boolean} FEATURE_PATIENT_FEEDBACK
 */

// Feature flags configuration
// These can be controlled via environment variables or admin panel
export const FEATURE_FLAGS = {
  FEATURE_VIDEO: process.env.REACT_APP_FEATURE_VIDEO === 'true',
  FEATURE_NOTIFICATIONS: process.env.REACT_APP_FEATURE_NOTIFICATIONS === 'true',
  FEATURE_NOTIFICATIONS_WS: process.env.REACT_APP_FEATURE_NOTIFICATIONS_WS === 'true',
  FEATURE_NOTIFICATIONS_WHATSAPP: process.env.REACT_APP_FEATURE_NOTIFICATIONS_WHATSAPP === 'true',
  FEATURE_NOTIFICATIONS_SENDGRID: process.env.REACT_APP_FEATURE_NOTIFICATIONS_SENDGRID === 'true',
  FEATURE_FILES: process.env.REACT_APP_FEATURE_FILES === 'true',
  FEATURE_ANALYTICS: process.env.REACT_APP_FEATURE_ANALYTICS === 'true',
  FEATURE_MESSAGING: process.env.REACT_APP_FEATURE_MESSAGING === 'true',
  FEATURE_FEEDBACK: process.env.REACT_APP_FEATURE_FEEDBACK === 'true',
  FEATURE_PATIENT_DASHBOARD: process.env.REACT_APP_FEATURE_PATIENT_DASHBOARD === 'true',
  FEATURE_PATIENT_MESSAGING: process.env.REACT_APP_FEATURE_PATIENT_MESSAGING === 'true',
  FEATURE_PATIENT_BILLING: process.env.REACT_APP_FEATURE_PATIENT_BILLING === 'true',
  FEATURE_PATIENT_FEEDBACK: process.env.REACT_APP_FEATURE_PATIENT_FEEDBACK === 'true',
};

// Default to true in development, false in production for unimplemented features
const defaultFlags = {
  FEATURE_VIDEO: process.env.NODE_ENV === 'development',
  FEATURE_NOTIFICATIONS: true, // Implemented
  FEATURE_NOTIFICATIONS_WS: true, // Implemented
  FEATURE_NOTIFICATIONS_WHATSAPP: false, // Stub only
  FEATURE_NOTIFICATIONS_SENDGRID: false, // Optional
  FEATURE_FILES: process.env.NODE_ENV === 'development',
  FEATURE_ANALYTICS: process.env.NODE_ENV === 'development',
  FEATURE_MESSAGING: true, // Implemented
  FEATURE_FEEDBACK: true, // Implemented
  FEATURE_PATIENT_DASHBOARD: true, // Implemented
  FEATURE_PATIENT_MESSAGING: true, // Implemented
  FEATURE_PATIENT_BILLING: true, // Implemented
  FEATURE_PATIENT_FEEDBACK: true, // Implemented
};

// Merge with defaults
export const getFeatureFlags = () => ({
  ...defaultFlags,
  ...FEATURE_FLAGS,
});

// Feature flag hook for components
export const useFeatureFlag = (flag) => {
  const flags = getFeatureFlags();
  return flags[flag];
};

// Feature flag component wrapper
export const FeatureFlag = ({ flag, children, fallback = null }) => {
  const isEnabled = useFeatureFlag(flag);
  return isEnabled ? children : fallback;
};

// Feature flag for routes
export const FeatureRoute = ({ flag, children, redirectTo = '/' }) => {
  const isEnabled = useFeatureFlag(flag);
  
  if (!isEnabled && redirectTo) {
    window.location.href = redirectTo;
    return null;
  }
  
  return isEnabled ? children : null;
}; 